import IItemSignatureRaw from "../IItemSignatureRaw";

export default class ItemSignatureRaw implements IItemSignatureRaw {
  constructor(
    public lot: string | undefined,
    public bestBefore: string | undefined,
    public expiry: string | undefined,
  ) {}
}
